import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Titulo from '../comum/Titulo';
import buscarEmpresasGestao from '../../actions/empresa/buscarEmpresasGestao';
import excluirEmpresa from '../../actions/empresa/excluirEmpresas';
import { alterouFiltro, alterouPagina, montarURLFiltro } from '../../util/filtros';
import { PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import ModalCadastrarEmpresa from './ModalCadastrarEmpresa';
import Empresa from './Empresa';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import buscarImpostosEmpresa from '../../actions/imposto-empresa/buscarImpostosEmpresa';
import buscarImpostos from '../../actions/imposto/buscarImpostos';

import ModalCadastrarImposto from '../imposto-empresa/ModalCadastrarImposto';
import PainelFiltragem from './PainelFiltrosEmpresas';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoEmpresas from './PaginacaoEmpresas';
import BotoesPaginacaoEmpresas from './BotoesPaginacaoEmpresas';
import determinarPaginaAtual from '../../actions/empresa/determinarPaginaAtualEmpresas';
import alterarRegistrosPorPagina from '../../actions/empresa/alterarRegistrosPorPaginaEmpresas';
import bloquearEmpresa from '../../actions/empresa/bloquearEmpresa';
import desbloquearEmpresa from '../../actions/empresa/desbloquearEmpresa';
import buscarPlataformas from '../../actions/empresa/buscarPlataformas';
import buscarGrupos from '../../actions/empresa/buscarGrupos';
import { showAlertMsg } from '../../util/messagesUtil';
import { tipoIntegracao } from '../../util/constantsUtil';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import {URL} from '../../util/ambienteActions';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-tabela-dados">
        <div className="row cabecalho-desktop">
            <div className="col">Nome</div>
            <div className="col">Nome fantasia</div>
            <div className="col">CNPJ/CPF</div>
            <div className="col">Email</div>
            <div className="col">Data de criação</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Ações</div>
        </div>
    </div>
);

const ModalConfirmacaoExclusaoEmpresa = ({ excluir, empresa }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoEmpresa" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir à empresa <strong>{empresa ? empresa.nome : ''}</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Cancelar
                    </button>
                    <button id="btn-confirmar-excluir-empresa" type="button" className="btn btn-laranja float-left"
                        data-dismiss="modal"
                        onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalConfirmacaoBloqueioEmpresa = ({ bloquearDesbloquear, empresa }) => (
    <div className="modal fade" id="modalConfirmacaoBloqueioEmpresa" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja {empresa && empresa.bloqueada ? 'desbloquear' : 'bloquerar'} à
                        empresa <strong>{empresa ? empresa.nome : ''}</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Cancelar
                    </button>
                    <button id="btn-confirmar-excluir-empresa" type="button" className="btn btn-laranja float-left"
                        data-dismiss="modal"
                        onClick={() => bloquearDesbloquear()}>Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>);


export class PainelGerenciarEmpresas extends React.Component {
    constructor(props) {
        super(props);
        this.selecionarEmpresa = this.selecionarEmpresa.bind(this);
        this.montarParametroEmpresa = this.montarParametroEmpresa.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.excluir = this.excluir.bind(this);

        this.state = {
            empresaSelecionada: null,
            textoFiltro: null,
            arquivo: null,
            impostos: [],
            sitesSelecionados: [],
            grupos: [],
            integracaoSelecionada: [],
            habilitadoRegraConexaoTrecho: true,
            pagamentosDesativadosSelecionados: []
        };
    }

    async downloadParte(url, size, from) {
        const urlFiltros = montarURLFiltro(this.props.filtrosAdicionados);
        
        let urlReq = `${url}?size=${size}&from=${from}&${urlFiltros}`;
        
        let retorno = await axios.get(urlReq, SLOW_REQUEST_CONFIG);
                
        return retorno.data;
    }
        
    executarDownload(arquivo) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], {type: 'text/csv;'}));
        a.download = 'Lista de Empresas.csv';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async exportarListaEmpresas() {
        let arquivo = 'Id Empresa;Nome Razão Social;Nome Fantasia;CNPJ;Email;Data Criação;Telefone;Grupo\n';
        let url = `${URL}/empresas`;
        
        let count = 0;
        let from = 1;
        let size = 10000;

        let qtd = this.props.total;        
        let totalParticoes = Math.ceil(qtd / 10000);
        
        for (let start = 0; start < totalParticoes; start += 1) {
            let retorno = await this.downloadParte(url, size, from);
            
            arquivo = `${arquivo}${retorno.empresas.map(it => {
                const telefone = (it.telefones && it.telefones.length > 0) ? it.telefones[0] : ''
                const grupo = it.grupo ? it.grupo : ''

                let valor = `"${it.id}";"${it.nome}";"${it.nomeFantasia}";${it.cnpj};${it.email};${it.dataCriacao};${telefone};${grupo}`
                if (it.configuracoesBPe.length > 0) {
                    valor = `${valor}\n;UF;Inscrição Estadual\n`
                    it.configuracoesBPe.forEach(it => {                                             
                        valor = `${valor};${it.uf};${it.inscricaoEstadual}\n`

                    });

                }

                return valor;

            }).join('\n')}\n`;

            from += 1;
            count += 1;

            if (count === totalParticoes) {
                this.executarDownload(arquivo)
            }            
        }

    }

    handleCheckedRegraConexaoTrecho(valor) {
        if (valor) {
            this.setState({ habilitadoRegraConexaoTrecho: valor });
        } else {
            this.setState({ habilitadoRegraConexaoTrecho: !this.state.habilitadoRegraConexaoTrecho });
        }
    }

    limparSitesSelecionados() {
        this.setState({ sitesSelecionados: [] })
    }

    selecionarSite(site) {
        const sites = this.state.sitesSelecionados;
        sites.push(site);
        this.setState({ sitesSelecionados: sites })
    }

    removerSite(site) {
        this.setState({ sitesSelecionados: this.state.sitesSelecionados.filter(it => it.value !== site) })

    }

    buscarEmpresasGestao() {
        this.props.buscarEmpresasGestao(this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    componentDidMount() {
        this.buscarEmpresasGestao();
        this.props.buscarPlataformas();
        this.props.buscarGrupos().then(resp => {
            if (resp.payload.status === 200) {
                this.setState({ grupos: resp.payload.data })
            }
        })
        this.props.buscarImpostos()
            .then(resp => {
                if (resp.payload.status === 200) {
                    this.setState({ impostos: resp.payload.data })
                }
            })
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
                this.props.alterarRegistrosPorPagina(10);
            }
            this.buscarEmpresasGestao();
        }
    }

    bloquearDesbloquear() {
        if (this.state.empresaSelecionada.bloqueada) {
            this.props.desbloquearEmpresa(this.state.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarEmpresasGestao();
                    }
                })
        } else {
            this.props.bloquearEmpresa(this.state.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarEmpresasGestao();
                    }
                })
        }
    }

    // renovar () {
    //   axios.post(`${URL}/empresa/atualizar-vinculo-mp`, {}, SLOW_REQUEST_CONFIG)
    //     .then(() => {
    //       Alert.success(
    //         `<div class='col-md-2 icone-feedback posicao-camada'>${ICONE_SUCESSO}</div>
    //               <div class='col-md-10 mensagem-feedback posicao-camada'>Vínculos Atualizados com sucesso</div>`,
    //         configuracaoMensagemAlerta
    //       )
    //     })
    // }

    buscarImpostoEmpresa(id) {
        this.props.buscarImpostosEmpresa(id)
    }

    limparEmpresaSelecionado() {
        this.setState({ empresaSelecionada: null });
    }


    excluir() {
        this.props.excluirEmpresa(this.state.empresaSelecionada.id)
            .then(() => {
                this.buscarEmpresasGestao();
                this.limparEmpresaSelecionado();
            })
    }

    selecionarOrigem(origem) {
        this.props.selecionarOrigem(origem);
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'idEmpresa', '');
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'nome', '');
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'email', '');
        this.limparEmpresaSelecionado();
    }

    preencherSitesSelecionados(sites) {
        if (sites) {
            this.setState({
                sitesSelecionados: sites.map(elemento => ({
                    label: elemento,
                    value: elemento
                }))
            })
        } else {
            this.setState({ sitesSelecionados: [] })
        }
    }

    preencherEmpresaIntegracoesSelecionados(integracoes) {
        const empresaIntegracoes = integracoes.map(it => {
            return {
                id: it.id,
                integracao: tipoIntegracao.find(ti => ti.value == it.tipoIntegracao),
                codigoEmpresa: it.codigoEmpresa,
                integracaoAtiva: it.ativo
            }
        })
        this.setState({
            integracaoSelecionada: empresaIntegracoes
        })
    }

    preencherPagamentosDesativadosSelecionados(pagamentos) {        
        this.setState({
            pagamentosDesativadosSelecionados: pagamentos.map(it => {
                return {
                    label: it,
                    value: it
                }
            })
        })
    }

    adicionarIntegracao(objetoIntegracao) {
        if (this.state.integracaoSelecionada.filter(it => it.integracao.value === objetoIntegracao.integracao.value).length === 0) {
            if (this.state.integracaoSelecionada.map(it => it.integracaoAtiva).some(it => it) && objetoIntegracao.integracaoAtiva) {
                showAlertMsg('Já existe uma integração ativa!');
                return;
            }

            const integracaoSelecionada = this.state.integracaoSelecionada;
            integracaoSelecionada.push(objetoIntegracao);

            this.setState({ integracaoSelecionada });

        }
    }

    limparIntegracaoSelecionada() {
        this.setState({
            integracaoSelecionada: []
        })
    }

    limparPagamentoDesativado() {
        this.setState({
            pagamentosDesativadosSelecionados: []
        })
    }

    adicionarPagamentoDesativado(evento) {        
        const pagamentosDesativadosSelecionados = [...this.state.pagamentosDesativadosSelecionados];

        if (!this.state.pagamentosDesativadosSelecionados.find(it => it.value === evento.value)) {
            const copia = Object.assign([], pagamentosDesativadosSelecionados);
            copia.push(evento)
            this.setState({pagamentosDesativadosSelecionados: copia })
        }

        
    }

    removerPagamentosDesativados(item) {
        this.setState({ pagamentosDesativadosSelecionados: this.state.pagamentosDesativadosSelecionados.filter(it => it.value !== item.value) })
    }

    handleCheckIntegracaoAtiva(objetoIntegracao) {
        const integracaoSelecionada = [...this.state.integracaoSelecionada];
        integracaoSelecionada.forEach(it => it.integracaoAtiva = false);
        const integracaoCorrente = integracaoSelecionada.find(f => f.integracao.value === objetoIntegracao.integracao.value);
        if (integracaoCorrente.integracaoAtiva) {
            integracaoCorrente.integracaoAtiva = false;
        } else {
            integracaoCorrente.integracaoAtiva = true;
        }
        const copiaListaIntegracao = Object.assign([], integracaoSelecionada);
        this.setState({ integracaoSelecionada: copiaListaIntegracao });
    }

    removerIntegracao(objetoIntegracao) {
        this.setState({ integracaoSelecionada: this.state.integracaoSelecionada.filter(it => it.integracao.value !== objetoIntegracao.integracao.value) })
    }

    montarParametroEmpresa(values) {
        return {
            id: values.codigoEmpresa,
            mensagemAvisoBilhete: values.mensagemAvisoBilhete,
            tempoVisualizacaoDados: values.tempoVisualizacaoDados,
            cnpj: values.cnpj,
            ie: values.ie,
            cnae: values.cnae,
            im: values.im,
            tar: values.tar,
            nome: values.razaoSocial,
            nomeFantasia: values.nomeFantasia,
            telefones: [values.telefoneEmpresa],
            email: values.email,
            base64Logomarca: values.logoMarca,
            logomarca: values.logomarca,
            urlImagem: values.urlImagem,
            endereco: {
                id: values.idEndereco,
                cep: values.cep,
                logradouro: values.logradouro,
                complemento: values.complemento,
                bairro: values.bairro,
                codigoCidade: this.props.origem.id,
                uf: this.props.origem.uf,
                numero: values.numero
            },
            sites: this.state.sitesSelecionados.map(it => it.value),
            nomeDono: values.nomeDono,
            telefoneDono: values.telefoneDono,
            nomeSocio: values.nomeSocio,
            telefoneSocio: values.telefoneSocio,
            nomeGerente: values.nomeGerente,
            telefoneGerente: values.telefoneGerente,
            opcoesTrechoAlternativo: values.opcoesTrechoAlternativo,
            habilitadoEncomenda: values.habilitadoEncomenda,
            permitirRemarcacaoCancelamentoSite: values.permitirRemarcacaoCancelamentoSite,
            habilitadoTEF: values.habilitadoTEF,
            ipTEF: values.ipTEF ? values.ipTEF : '',
            multaRemarcacaoCancelamentoDentroPrazo: values.multaRemarcacaoCancelamentoDentroPrazo,
            multaRemarcacaoCancelamentoForaPrazo: values.multaRemarcacaoCancelamentoForaPrazo,
            habilitadoBpe: values.habilitadoBpe,
            habilitadoBpeSites: values.habilitadoBpeSites,
            habilitadoSite: values.habilitadoSite,
            rodoviaria: values.rodoviaria,
            turismo: values.turismo,
            senhaAntt: values.senhaAntt == '********' ? null : values.senhaAntt,
            habilitadoBuscaReservaComBpe: values.habilitadoBuscaReservaComBpe,
            dataIniciaoVigenciaBuscaReservaComBpe: values.dataIniciaoVigenciaBuscaReservaComBpe,
            nomeSite: values.nomeSite,
            senhaCertificado: values.senhaCertificado,
            nomeCertificado: values.nomeCertificado,
            grupo: values.grupo ? values.grupo.value : null,
            habilitadaVendaSeguro: values.habilitadaVendaSeguro,
            habilitadoAgencia: values.habilitadoAgencia,
            habilitadoValorAntt: values.habilitadoAntt,
            impostoPraticar: values.impostoPraticar,
            comissaoPraticar: values.comissaoPraticar,
            agenteTipoUm: values.agenteTipoUm,
            agenteTipoDois: values.agenteTipoDois,
            agenteTipoTres: values.agenteTipoTres,
            notaEmpresa: values.avaliacaoEmpresa ? values.avaliacaoEmpresa : '0.0',
            habilitadoEnvioWpp: values.habilitadoEnvioWpp,
            integracoes: this.state.integracaoSelecionada.map(it => {
                return {
                    id: it.id,
                    codigoEmpresa: it.codigoEmpresa,
                    tipoIntegracao: it.integracao.value,
                    ativo: it.integracaoAtiva
                }
            }),
            numeroNotaCte: values.numeroNotaCte,
            numeroNotaCteOs: values.numeroNotaCteOs,
            habilitadoRegraBilhete: values.habilitadoRegraBilhete,
            habilitadoRegraConexaoTrecho: this.state.habilitadoRegraConexaoTrecho,
            habilitadoBuscaPassagemHorario: values.habilitadoBuscaPassagemHorario,
            habilitadoVendeGratuidadeApenasConvencional: values.habilitadoVendeGratuidadeApenasConvencional,
            habilitadoVenderCpfOpcional: values.habilitadoVenderCpfOpcional,
            habilitadoExibirApenasTipoDocumentoPassaporte: values.habilitadoExibirApenasTipoDocumentoPassaporte,
            habilitadoCpfCnpjTitularCompravante: values.habilitadoCpfCnpjTitularCompravante,
            pagamentosDesativados: this.state.pagamentosDesativadosSelecionados.map(it => it.value),
            habilitadoPrecoFixoExcessoBagagem: values.habilitadoPrecoFixoExcessoBagagem,
            precoFixoExcessoBagagem: values.precoFixoExcessoBagagem ? values.precoFixoExcessoBagagem.replace('R$', '') : null
        };
    }

    selecionarEmpresa(empresa) {
        this.setState({ empresaSelecionada: empresa });
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotoes() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-right">
                            <button className="btn btn-laranja mr-2"
                                onClick={() => this.exportarListaEmpresas()}>
                                Exportar Lista
                            </button>
                            
                            <button data-toggle="modal" data-target="#modalCadastrarEmpresa"
                                className="btn btn-laranja">
                                Nova Empresa
                            </button>
                        </div>
                    </div>
                </div>
            </Autorizacao>)
    }

    exibirTabelaEmpresas() {
        if (this.props.empresas && this.props.empresas.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoEmpresas}
                    BotoesPaginacao={BotoesPaginacaoEmpresas}>
                    <div className="col-12 conteudo-internas">
                        <CabecalhoTabela />
                        <div className="lista-table">
                            {this.exibirEmpresas()}
                        </div>
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
        return <div>Nenhuma empresa cadastrada</div>;
    }

    exibirEmpresas() {
        return this.props.empresas
            .map((empresa, index) => <Empresa key={index} empresa={empresa}
                preencherSitesSelecionados={this.preencherSitesSelecionados.bind(this)}
                selecionarOrigem={this.selecionarOrigem.bind(this)}
                buscarImpostoEmpresa={this.buscarImpostoEmpresa.bind(this)}                
                selecionarEmpresa={this.selecionarEmpresa}
                preencherEmpresaIntegracoesSelecionados={this.preencherEmpresaIntegracoesSelecionados.bind(this)}
                handleCheckedRegraConexaoTrecho={this.handleCheckedRegraConexaoTrecho.bind(this)}
                preencherPagamentosDesativadosSelecionados={this.preencherPagamentosDesativadosSelecionados.bind(this)}
                indice={index} />)
    }

    exibirFiltro() {
        return <div className="row">
            <div className="col-md-12">
                <div className="text-right">
                    <PainelFiltragem />
                </div>
            </div>
        </div>
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Empresas" urlRetorno="/" />
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            {this.exibirFiltro()}                            
                            {this.exibirBotoes()}
                            <div className="lista-table">
                                {this.exibirTabelaEmpresas()}
                            </div>
                        </div>
                    </div>
                </div>
                <ModalCadastrarEmpresa                    
                    pagamentosDesativadosSelecionados={this.state.pagamentosDesativadosSelecionados}
                    limparSitesSelecionados={this.limparSitesSelecionados.bind(this)}
                    selecionarSite={this.selecionarSite.bind(this)}
                    removerSite={this.removerSite.bind(this)}
                    sitesSelecionados={this.state.sitesSelecionados}
                    selecionarOrigem={this.selecionarOrigem.bind(this)}
                    cidade={this.props.origem}
                    montarParametroEmpresa={this.montarParametroEmpresa}
                    empresa={this.state.empresaSelecionada}
                    buscarEmpresas={this.buscarEmpresasGestao.bind(this)}
                    grupos={this.state.grupos}
                    selecionarEmpresa={this.selecionarEmpresa}
                    integracaoSelecionada={this.state.integracaoSelecionada}
                    adicionarIntegracao={this.adicionarIntegracao.bind(this)}
                    removerIntegracao={this.removerIntegracao.bind(this)}
                    handleCheckIntegracaoAtiva={this.handleCheckIntegracaoAtiva.bind(this)}
                    limparIntegracaoSelecionada={this.limparIntegracaoSelecionada.bind(this)}
                    habilitadoRegraConexaoTrecho={this.state.habilitadoRegraConexaoTrecho}
                    handleCheckedRegraConexaoTrecho={this.handleCheckedRegraConexaoTrecho.bind(this)}
                    adicionarPagamentoDesativado={this.adicionarPagamentoDesativado.bind(this)}
                    removerPagamentosDesativados={this.removerPagamentosDesativados.bind(this)}
                    limparPagamentoDesativado={this.limparPagamentoDesativado.bind(this)}
                    
                />
                <ModalCadastrarImposto
                    buscarImpostosEmpresa={this.buscarImpostoEmpresa.bind(this)}
                    impostosEmpresa={this.props.impostosEmpresa}
                    empresa={this.state.empresaSelecionada}
                    impostos={this.state.impostos} />
                <ModalConfirmacaoExclusaoEmpresa excluir={this.excluir} empresa={this.state.empresaSelecionada}
                    buscarEmpresas={this.buscarEmpresasGestao.bind(this)} />
                <ModalConfirmacaoBloqueioEmpresa
                    bloquearDesbloquear={this.bloquearDesbloquear.bind(this)}
                    empresa={this.state.empresaSelecionada} />                

            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => {
    
    return {
        empresas: state.empresasGestao.empresas,
        total: state.empresasGestao.total,
        origem: state.origem,
        impostosEmpresa: state.impostoEmpresa.impostosEmpresa,
        paginaAtual: state.paginaAtualEmpresa,
        registrosPorPagina: state.registrosPorPaginaEmpresa,
        filtrosAdicionados: state.filtrosAdicionadosEmpresas,        
        changeFieldValue
    }
};


export default connect(mapStateToProps,
    {
        buscarEmpresasGestao,
        excluirEmpresa,
        selecionarOrigem,
        buscarImpostosEmpresa,
        buscarImpostos,
        determinarPaginaAtual,
        alterarRegistrosPorPagina,
        desbloquearEmpresa,
        bloquearEmpresa,
        buscarPlataformas,
        buscarGrupos        
    })(reduxForm({
        form: 'formularioCadastroEmpresa'
    })(PainelGerenciarEmpresas))
